import type {StateProvider} from '@uirouter/angularjs';
import {KpSvelteComponentWrapperComponent} from 'core/kp-svelte-component-wrapper/kp-svelte-component-wrapper.component';

/*@ngInject*/
export function statsRoutes($stateProvider: StateProvider) {
    let publicStatsModule: { default: any; };
    let overallStatsModule: { default: any; };
    let zStatsModule: { default: any; };

    $stateProvider
        .state({
            name: 'public-stats',
            url: '/stats?fromDate&toDate&timeGranularity',
            params: {
                fromDate: {dynamic: true},
                toDate: {dynamic: true},
                timeGranularity: {dynamic: true}
            },
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => publicStatsModule.default,
            },
            lazyLoad: async () => {
                publicStatsModule = await import(/* webpackChunkName: "publicStats" */ './public/KpPublicStats.svelte');
                return null;
            }
        })
        .state({
            name: 'overall-stats',
            url: '/stats/overall?fromDate&toDate&department&location',
            params: {
                fromDate: {dynamic: true},
                toDate: {dynamic: true},
                department: {dynamic: true},
                location: {dynamic: true}
            },
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => overallStatsModule.default,
            },
            lazyLoad: async () => {
                overallStatsModule = await import(/* webpackChunkName: "overallStats" */ './overall/KpOverallStats.svelte');
                return null;
            }
        })
        .state({
            name: 'z-stats',
            url: '/stats/z',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => zStatsModule.default,
            },
            lazyLoad: async () => {
                zStatsModule = await import(/* webpackChunkName: "zStats" */ './z-stats/KpZStats.svelte');
                return null;
            }
        });
}